import { useEffect, useRef } from 'react';

export const useEscapeKey = (isActive: boolean, handleEscape: () => void) => {
  const handleEscapeRef = useRef(handleEscape);
  handleEscapeRef.current = handleEscape;

  useEffect(() => {
    if (!isActive) {
      return;
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        handleEscapeRef.current();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isActive]);
};
